exports.f = {}.propertyIsEnumerable;


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/core-js/modules/_object-pie.js
// module id = 47
// module chunks = 0